import { render, staticRenderFns } from "./ManageServices.vue?vue&type=template&id=19553ed2&scoped=true&"
import script from "./ManageServices.vue?vue&type=script&lang=js&"
export * from "./ManageServices.vue?vue&type=script&lang=js&"
import style0 from "./ManageServices.vue?vue&type=style&index=0&id=19553ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19553ed2",
  null
  
)

export default component.exports